import * as BABYLON from '@babylonjs/core';

import getShader_renderStars from './compute/compute-render-stars.js'
import getShader_clearTex from './compute/compute-clear-tex.js'

import starTexPath from '../assets/textures/star.png';

class StarsRenderer {
    init(scene, engine, camera, canvas) {
        this.engine = engine;

        this.width = canvas.width;
        this.height = canvas.height;
        this.mainTexture = BABYLON.RawTexture.CreateRGBAStorageTexture(null, this.width, this.height, scene, false, false);

        this.starTexture = new BABYLON.Texture(starTexPath, scene);

        const computeShader = this.computeShader = getShader_renderStars(engine);

        this.shaderParams = new BABYLON.UniformBuffer(engine, undefined, undefined, "shaderParams");
        this.shaderParams.addUniform("viewMatrix", 16);
        this.shaderParams.addUniform("projectionMatrix", 16);
        this.shaderParams.addUniform("numStars", 1);
        computeShader.setUniformBuffer("params", this.shaderParams);

        computeShader.setStorageTexture("mainTex", this.mainTexture);
        computeShader.setTexture("starTex", this.starTexture);

        this.updateMatrices(camera);

        this.computeShader_clearTex = getShader_clearTex(engine);
        this.computeShader_clearTex.setStorageTexture("mainTex", this.mainTexture);
    }

    updateMatrices(camera) {
        this.shaderParams.updateMatrix("viewMatrix", camera.getViewMatrix());
        this.projectionMatrix = camera.getProjectionMatrix();
        this.shaderParams.updateMatrix("projectionMatrix", this.projectionMatrix);
        this.shaderParams.update();
    }

    updatePositions(positions, engine) {
        this.numStars = positions.length;
        this.shaderParams.updateInt("numStars", this.numStars);
        this.shaderParams.update();

        if(this.positionBuffer) {
            this.positionBuffer.dispose();
        }
        this.positionBuffer = new BABYLON.StorageBuffer(engine, this.numStars * 3 * 4, BABYLON.Constants.BUFFER_CREATIONFLAG_VERTEX | BABYLON.Constants.BUFFER_CREATIONFLAG_WRITE);
        const positionsF32 = new Float32Array(this.numStars * 3 * 4);
        for(let i = 0; i < this.numStars; i++) {
            positionsF32[i*3 + 0] = positions[i].x;
            positionsF32[i*3 + 1] = positions[i].y;
            positionsF32[i*3 + 2] = positions[i].z;
        }
        this.positionBuffer.update(positionsF32);
        if(this.positionBuffer) {
            this.computeShader.setStorageBuffer("positions", this.positionBuffer);
        }
        else
        {
            throw new Error("FATAL: Failed to create star positions buffer!");
        }

        this.debugVals = new BABYLON.StorageBuffer(engine, 4 * 16, BABYLON.Constants.BUFFER_CREATIONFLAG_READWRITE);
        this.computeShader.setStorageBuffer("debugVals", this.debugVals);
    }

    apply() {
        let blockDim = 8;
        let numPixels = this.width * this.height;
        let numWorkgroupsX = Math.ceil(this.width / blockDim);
        let numWorkgroupsY = Math.ceil(this.height / blockDim);
        this.computeShader_clearTex.dispatchWhenReady(numWorkgroupsX, numWorkgroupsY).then(() => {
        });
        blockDim = 64;
        return this.computeShader.dispatchWhenReady(Math.ceil(this.numStars / blockDim)); 
        /*
        */
    }
}


export default StarsRenderer;